import { TableRow } from '@mui/material';

import withStyles from '@mui/styles/withStyles';

const StyledTableRow = withStyles(theme => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

export default StyledTableRow;
